import React, {useEffect, useState} from "react";
import api from 'api';
import {Routes, Route, Link} from 'react-router-dom';
//import { API } from "../../common/config-api";
import { API } from "common/config-api"; // jsconfig.json

const SalesRow = ({s}) => {
  console.log(s);

  const salesProducts = async (sIdx) => {
    try {
      const response = await api.get(`${API.SALES_DAY}` + sIdx);
      const resp = response;
      console.log("resp", resp);
      let alertStr = "";
      alertStr += "salesIdx: " + resp.salesIdx + "\n";
      alertStr += "salesDate: " + resp.salesDate + "\n";
      alertStr += "salesReceived: " + resp.salesReceived + "\n";
      alertStr += "salesChange: " + resp.salesChange + "\n";
      alertStr += "userNickname: " + resp.userNickname + "\n";
      alertStr += "\n";
      resp.salesProducts.forEach(function(arr){
        alertStr += "productCode: " + arr.productCode + "\n";
        alertStr += "productName: " + arr.productName + "\n";
        alertStr += "productPrice: " + arr.salesProductPrice + "\n";
        alertStr += "productQuantity: " + arr.salesProductQuantity + "\n";
      alertStr += "======================================\n";
    });
    console.log(alertStr);
    alert(alertStr);
    } catch (error) {
      console.error('판매 상세 조회 실패:', error);
      alert('판매 상세 조회 중 오류가 발생했습니다.');
    }
  }

  return (
    <tr>
    <td>
    {s.salesIdx}<br />
    <span style={{fontSize: "12px"}}>{s.salesDate}</span>
    </td>
    <td>{s.salesPrice.toLocaleString('ko-KR')}</td>
    <td>xxx <span style={{fontSize: "12px"}}>(10%)</span></td>
    <td>0</td>
    <td>0</td>
    <td>{s.salesProductCnt}</td>
    <td>
      {/*<span data-bs-toggle="modal" data-bs-target="#basicModal">*/}
      <span onClick={() => {salesProducts(s.salesIdx)}} >
        <b>{s.userNickname}</b>
      </span>

      {/*<div class="modal fade" id="basicModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Basic Modal</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              {modalContents}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div>
          </div>
        </div>
      </div>*/}

    </td>              
  </tr>
  
  );
}

const SalesEmpty = () => {
  return (
  <tr>
    <td colSpan="10">조회된 판매정보가 없습니다.</td>               
  </tr>    
  );
}


const SalesDay = () => {

  const nowDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2);
    const day = ('0' + today.getDate()).slice(-2);
    const now = year + "-" + month  + "-" + day;
    return now;
  }

    const today = nowDate();

    console.log(today);

    const selectDate = (e) => {
        console.log(e.target.value);
    }



    const [search, setSearch] = useState({
      date: today,
      keyword: '',
    });
    
    const [salesList, setSalesList] = useState([]);
  
    const getSalesList = async () => {
      try {
        const queryString = Object.entries(search).map((e) => e.join('=')).join('&');
        console.log(`${API.SALES_DAY}?` + queryString);
        const response = await api.get(`${API.SALES_DAY}?` + queryString);
        const resp = response;
        console.log("resp", resp);
        if(typeof(resp) === "object"){
          setSalesList(resp);
        }else{
          alert("검색된 판매기록이 없습니다.");
        }
      } catch (error) {
        console.error('판매 목록 조회 실패:', error);
        alert('판매 목록 조회 중 오류가 발생했습니다.');
      }
    }

    const onChange = (event) => {
      const { value, name } = event.target; //event.target에서 name과 value만 가져오기
      setSearch({
        ...search,
        [name]: value,
      });
    };

    useEffect(() => {
      getSalesList();
    }, []);


    return (
        <div className="row">


        <div className="card">
          <div className="card-body">
            <h5 className="card-title">daysales list</h5>


            <div className="row mb-3">
              <div className="col-sm-4">
                <input type="date" className="form-control" name="date" onChange={onChange} defaultValue={today} />
              </div>
              <div className="col-sm-4">
                <input type="text" className="form-control" name="keyword" onChange={onChange} placeholder="검색어(회원, 상품)" defaultValue={''} />
              </div>
              <div className="col-sm-4">
                <button type="button" className="btn btn-primary" onClick={getSalesList}>Search</button>
              </div>

            </div>


            <table className="table">
              <thead>
                <tr>
                  <th scope="col">
                    거래ID<br /><span style={{fontSize:"12px"}}>거래일시</span>
                  </th>
                  <th scope="col">소계</th>
                  <th scope="col">포인트</th>
                  <th scope="col">쿠폰</th>
                  <th scope="col">세금</th>
                  <th scope="col">수량</th>
                  <th scope="col">회원</th>
                </tr>
                <tr>
                </tr>
              </thead>
              <tbody>

              {salesList[0] === null || salesList.length === 0 ? <SalesEmpty /> : null}
              {salesList.map((sales, idx) => ( <SalesRow key={idx} s={sales} /> ))}


              </tbody>
            </table>





          </div>
        </div>
        </div>


    );

}

export default SalesDay;